module.exports = __webpack_public_path__ + "static/media/IconTemplates_-62.9d1842d7.svg";